<template>
  <div>
    <div
      ref="events_carousel"
      :class="'landing_slider event_slider' + (isGridView ? ' flex_box' : '')"
    >
      <button
        v-if="pagination.running"
        type="button"
        data-role="none"
        class="slick-next-loading"
        aria-label="Next"
        role="button"
        aria-disabled="false"
        style="top: -70px; right: 190px; cursor: unset;"
      >
        <img class="lazyload" :data-src="contentCloudFrontWithVersion('/ellipsis.svg')">
      </button>
      <event-card v-for="event in displayEvents" :key="event.id" :event="event" :page="page" />
    </div>
    <!-- comment for issue GAME - 8754 -->
    <!-- <div v-if="checkLightTheme()" class="light-theme-slick-arrow">
      <div ref="arrow_prev" class="light_theme_arrow left" />
      <div ref="arrow_next" class="light_theme_arrow right" />
    </div> -->
  </div>
</template>

<script>
import EventCard from './EventCard';
import 'slick-carousel/slick/slick.min';
import { component } from '../../mixins/component';
import { helper } from '../../mixins/helper';
import { ConfigMixin } from '../../mixins/config';
import jQuery from 'jquery';
import Vue from 'vue';

const SLICK_RESPONSIVE_CONFIG_EVENTS = [
  {
    breakpoint: 1500,
    settings: {
      initialSlide: 0,
      slidesToShow: 4,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 1220,
    settings: {
      initialSlide: 0,
      slidesToShow: 3,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 1000,
    settings: {
      initialSlide: 0,
      slidesToShow: 3,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 840,
    settings: {
      initialSlide: 0,
      slidesToShow: 2,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 500,
    settings: {
      initialSlide: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
];

export default {
  components: { EventCard },
  mixins: [component, ConfigMixin, helper],
  props: {
    events: {
      type: Object,
      default() {
        return {};
      },
    },
    page: {
      type: String,
      default: '',
    },
    slideToShow: {
      type: Number,
      default: 4,
    },
    isGridView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayEvents: [],
      pagination: {
        page: 1,
        running: false,
        limit: 0,
      },
    };
  },
  watch: {
    events: {
      handler: function(newVal, oldVal) {
        if (this.$refs.events_carousel) {
          console.log(newVal);
          this.displayEvents = newVal.data.content;
          this.destroyCarousel();
          Vue.nextTick(() => {
            this.initCarousel();
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.page === 'events' || this.page === 'search') {
      this.pagination.limit = 15;
    } else {
      this.pagination.limit = this.LIMIT_DEFAULT_SLICK_EVENT;
    }
    this.displayEvents = this.events.data.content;
    Vue.nextTick(() => {
      this.initCarousel();
    });
  },
  methods: {
    initCarousel() {
      // comment for issue GAME - 8754
      // if (this.checkLightTheme()) {
      //   jQuery(this.$refs.events_carousel).slick({
      //     rows: 0,
      //     infinite: false,
      //     speed: 300,
      //     slidesToShow: this.slideToShow,
      //     initialSlide: 0,
      //     draggable: false,
      //     slidesToScroll: 1,
      //     variableWidth: true,
      //     centerMode: false,
      //     prevArrow: jQuery(this.$refs.arrow_prev),
      //     nextArrow: jQuery(this.$refs.arrow_next),
      //     responsive: SLICK_RESPONSIVE_CONFIG_EVENTS,
      //   });
      // } else {
      jQuery(this.$refs.events_carousel).slick({
        rows: 0,
        infinite: false,
        speed: 300,
        slidesToShow: this.slideToShow,
        initialSlide: 0,
        draggable: false,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: false,
        responsive: SLICK_RESPONSIVE_CONFIG_EVENTS,
      });
      // }
      if (this.page !== 'search') {
        this.initCarouselLoadMore();
      }
    },
    initCarouselLoadMore() {
      jQuery(this.$refs.events_carousel).on('afterChange', (event, slick, currentSlide) => {
        const elem = jQuery(this.$refs.events_carousel);
        const slidesToShow = slick.slickGetOption('slidesToShow');
        // if (slidesToShow === 1) {
        //   slidesToShow = slidesToShow + 2;
        // } else {
        const slideCount = this.displayEvents.length;
        console.log('current slide: ' + currentSlide);
        console.log('slide show: ' + slidesToShow);
        if (currentSlide >= slideCount - slidesToShow) {
          if (!this.pagination.running) {
            this.pagination.running = true;
            const url = this.events.url + '&page=' + (this.pagination.page + 1) + '&limit=' + this.pagination.limit;
            elem.find('.slick-next').first().addClass('btn_slick_disable');
            console.log('request get more event by slick');
            this.$http.get(url)
              .then(response => {
                this.pagination.running = false;
                if (response.data.count === 0) {
                  console.log('slick get no events');
                  elem.off('afterChange');
                  elem.find('.slick-next').first().addClass('btn_slick_disable');
                  elem.on('afterChange', (event, slick, currentSlide) => {
                    if (currentSlide > slideCount - slidesToShow - 1) {
                      elem.find('.slick-next').first().addClass('btn_slick_disable');
                    } else {
                      elem.find('.slick-next').first().removeClass('btn_slick_disable');
                    }
                  });
                } else {
                  console.log('slick update events');
                  this.destroyCarousel();
                  for (let i = 0; i < response.data.content.length; i++) {
                    this.displayEvents.push(response.data.content[i]);
                  }
                  this.pagination.page++;
                  Vue.nextTick(() => {
                    this.initCarousel();
                    jQuery(this.$refs.events_carousel).slick('slickGoTo', currentSlide, true);
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.pagination.running = false;
              })
              .finally(() => {
                this.pagination.running = false;
              });
          }
        }
        return true;
        // }
      });
    },
    destroyCarousel() {
      jQuery(this.$refs.events_carousel).off('afterChange');
      jQuery(this.$refs.events_carousel).slick('unslick');
    },
  },
};
</script>
<style lang="scss">
    @media (max-width: 1500px){
        .event_slider {
            width: 100%!important;
        }
    }
</style>
